import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Link, scroller } from 'react-scroll';
import { Headline } from '../../../../../components/Typography';
import hextoRgba from '../../../../../../src/utils/hexToRgbA';
import appConfig from '../../../../../../app-config';

const Wrapper = styled.div`
  height: 64px;
  max-width: 100vw;
  background: ${(props) => props.theme.categoriesBarBackgroundColor};
  z-index: 2;
  font-family: ${appConfig.appFontFamily};
  position: sticky;
  top: 80px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

  ${(props) => {
    if (!props.firstCategory) {
      return css`
        :before{
        position:absolute;
        top:0;
        bottom:0;
        left:5%;
        width:3em;
        content:'';
        background: -webkit-linear-gradient(
          left,
          ${hextoRgba(props.theme.categoriesBarBackgroundColor, 1)} 0%,
          ${hextoRgba(props.theme.categoriesBarBackgroundColor, 0)} 0%
        );
        background:-o-linear-gradient(
          left,
    rgba(255,255,255,1)0%,
    rgba(255,255,255,0) 100%
    );
        background:-webkit-gradient(
    linear,
   left top,
          right top,
          color-stop(0%, rgba(255, 255, 255, 0)),
          color-stop(100%, rgba(255, 255, 255, 1))
        );
      }
    `;
    }
    return null;
  }}

  ${(props) => {
    if (!props.isScrollToEnd) {
      return css`
       :after {
          position:absolute;
          top: 0;
          bottom: 0;
          right: 5%;
          width: 3em;
          content:'';
          background: -webkit-linear-gradient(
            left,
            ${hextoRgba(props.theme.categoriesBarBackgroundColor, 0)} 0%,
            ${hextoRgba(props.theme.categoriesBarBackgroundColor, 1)} 100%
          );
          background:-o-linear-gradient(
            left,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 100%
          );
          background:-webkit-gradient(
            linear,
            left top,
            right top,
            color-stop(0%, rgba(255, 255, 255, 0)),
            color-stop(100%, rgba(255, 255, 255, 1))
          );
        }
      `;
    }
    return null;
  }}

  @media (max-width: 786px) {
    top: 70px;
    height: 48px;
    // margin-left: -20px;
    // margin-right: -20px;
  }
`;

const InsideDiv = styled.div`
  text-align: center;
  margin: 0 5%;
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  align-items: center;
  grid-gap: 20px;
  margin-bottom: 42px;
  color: ${(props) => props.theme.categoriesBarFontColor};
  .activeMenuLink {
    padding: 0 15px;
    color: ${(props) => props.theme.categoriesBarSelectedFontColor};
    div {
      padding-top: 3px;
      border-bottom: 3px solid;
      height: 80%;
      ${(props) => props.theme.categoriesBarSelectedBorderColor};
      border-bottom: 3px solid
        ${(props) => props.theme.categoriesBarSelectedBorderColor};
    }
  }

  scroll-behavior: smooth;
  overflow-x: ${(props) => (props.hasScroll ? 'auto' : 'scroll')};
  -webkit-overflow-scrolling: touch;
  scrollbar-width: ${(props) =>
    props.hasScroll ? '3px' : 'none'}; /* Firefox */
  -ms-overflow-style: ${(props) =>
    props.hasScroll ? 'default' : 'none'}; /* IE 10+ */
  ::-webkit-scrollbar {
    display: ${(props) => (props.hasScroll ? 'block' : 'none')};
    width: 3px;
    height: 3px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.headerBackgroundColor};
    cursor: pointer;
  }
`;

const CategoryLink = styled(Link)`
  height: 64px;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    color: ${(props) => props.theme.categoriesBarHoverColor};
    transition: all 0.25s ease;
  }
  @media (max-width: 786px) {
    height: 48px;
  }
`;

const CategoryName = styled(Headline)`
  color: inherit;
  display: flex;
  align-items: center;
  height: 64px;
  text-transform: ${(props) =>
    props.theme.categoriesBarTextUppercase || 'none'};
  &:hover {
    color: ${(props) => props.theme.categoriesBarHoverColor};
    transition: all 0.25s ease;
  }

  @media (max-width: 786px) {
    padding-right: ${(props) => (props.isLastCategory ? '20px' : '0')};
    height: 48px;
  }
`;

const DURATION = 300;

const CategoriesBar = ({ categories, dontSelectMyOrders }) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const [isScrollToEnd, setisScrollToEnd] = useState(false);
  const [firstCategory, setFirstCategory] = useState(true);

  const scrollListener = () => {
    const scrollWrapper = document.getElementById('scrollWrapper');
    setisScrollToEnd(
      scrollWrapper.scrollWidth - scrollWrapper.scrollLeft ===
        scrollWrapper.clientWidth
    );
  };

  useEffect(() => {
    if (dontSelectMyOrders) {
      scroller.scrollTo('category_1', {
        offset: window.innerWidth > 768 ? 207 : 171,
      });
    }

    document
      .getElementById('scrollWrapper')
      .addEventListener('scroll', scrollListener);

    return () => {
      document
        .getElementById('scrollWrapper')
        .removeEventListener('scroll', scrollListener);
    };
  }, []);

  const scrollCategoriesBar = (index, cb) => {
    const scrollWrapper = document
      .getElementById('scrollWrapper')
      .getBoundingClientRect();
    const activeCategory = document
      .getElementById(`category_${index}`)
      .getBoundingClientRect();

    if (index === 0) setFirstCategory(true);
    else setFirstCategory(false);

    document.getElementById('scrollWrapper').scrollLeft +=
      activeCategory.left - scrollWrapper.left - 35; // use -20 to show just the selected category
    if (cb) cb();
  };

  return (
    <Wrapper isScrollToEnd={isScrollToEnd} firstCategory={firstCategory}>
      <InsideDiv id='scrollWrapper' hasScroll={appConfig.appSource === 'maker'}>
        {categories.map((category, index) => {
          const offset = index === 0 ? -220 : -160;
          const isLastCategory = index + 1 === categories.length;
          return (
            <CategoryLink
              activeClass='activeMenuLink'
              id={`category_${index}`}
              to={`${category.name.toLowerCase()}_${category.category_id}`}
              spy={true}
              smooth={true}
              duration={DURATION}
              offset={offset}
              key={category.category_id}
              onSetActive={() => {
                if (!isScrolling) {
                  scrollCategoriesBar(index);
                }
              }}
              onClick={() => {
                if (isScrolling) {
                  setIsScrolling(true);
                  scrollCategoriesBar(index, () => {
                    setTimeout(() => setIsScrolling(false), DURATION); // this is not true 'waiting'. simply guessing
                  });
                }
              }}
            >
              <CategoryName
                id='MenuaB-CategoryName'
                isLastCategory={isLastCategory}
              >
                {category.name}
              </CategoryName>
            </CategoryLink>
          );
        })}
      </InsideDiv>
    </Wrapper>
  );
};

export default CategoriesBar;

// const Wrapper = styled.div`
//   height: 64px;
//   display: grid;
//   grid-auto-flow: column;
//   justify-content: flex-start;
//   align-items: center;
//   grid-gap: 20px;
//   padding: 0 10%;
//   width: 100vw;
//   background: ${props => props.theme.categoriesBarBackgroundColor};
//   text-align: center;
//   overflow-x: scroll;
//   -webkit-overflow-scrolling: touch;
//   scrollbar-width: none; /* Firefox */
//   -ms-overflow-style: none; /* IE 10+ */
//   ::-webkit-scrollbar {
//     display: none;
//   }
//   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
//   margin-bottom: 42px;
//   position: sticky;
//   top: 80px;
//   color: ${props => props.theme.categoriesBarFontColor};
//   .activeMenuLink {
//     color: ${props => props.theme.categoriesBarSelectedFontColor};
//     div {
//       padding-top: 3px;
//       border-bottom: 3px solid
//         ${props => props.theme.categoriesBarSelectedBorderColor};
//     }
//   }
//   z-index: 2;

//   @media (max-width: 786px) {
//     top: 56px;
//     height: 48px;
//     margin-left: -20px;
//     margin-right: -20px;
//   }
// `;
